import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary/5 to-background min-h-[80vh] flex items-center">
      {/* Background Effects */}
      <div className="absolute inset-0 w-full h-full">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-4xl mx-auto text-center stagger-animation">
          <motion.div
            className="mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold text-primary flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0">
              <div className="whitespace-nowrap">Find Your Perfect</div>
              <div className="flex items-center">
                <img 
                  src="/lovable-uploads/f7cec12b-685c-41ca-bf44-dda5fa89dc2e.png" 
                  alt="PEO Logo" 
                  className="h-8 sm:h-10 md:h-12 w-auto mx-2 sm:mx-3" 
                />
                <div className="whitespace-nowrap">Match</div>
              </div>
            </h1>
          </motion.div>
          
          <motion.p 
            className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Streamline your PEO shopping with our patent pending single application and matching technology. 
            Compare quotes and buy directly from the app, or only talk to vendors after you confirm fit and price.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Button 
              size="lg"
              className="bg-primary hover:bg-primary/90 text-white"
              onClick={() => navigate("/signup")}
            >
              Get Started Now
            </Button>
            
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => navigate("/about")}
            >
              Learn More
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
